/// <reference path="./next-i18next.config.d.ts" />

const i18nConfig = {
  defaultLocale: "en-US",
  locales: ["en-US", "es"],
  localeDetector: false,
};

module.exports = i18nConfig;
